import React from "react";
import Flagship from "../../core/flagship";
import {
  addMentions,
  empty,
  getFormattedValue,
  getTimezone,
  isEqual,
  renderFieldValue
} from "../../utils/helpers";
import { Loader, Label, Segment, Icon, Button, Feed } from "semantic-ui-react";
import Linkify from "react-linkify";
import moment from "moment-business-days";

class SingleRecordHistory extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.refreshFeed = this.refreshFeed.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
    this.getData = this.getData.bind(this);
    this.renderPagination = this.renderPagination.bind(this);
  }

  getInitialState() {
    return {
      offset: 0,
      items: [],
      error: "",
      loading: false
    };
  }

  componentDidMount() {
    this.refreshFeed();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.instance !== this.props.instance && nextProps.userId !== 0) {
      this.refreshFeed();
    }
  }

  nextPage() {
    let newOffset = this.state.offset + 5;
    this.setState({
      offset: newOffset
    });
    this.getFeedItems(newOffset);
  }

  prevPage() {
    let newOffset = this.state.offset - 5;
    if (newOffset < 0) {
      newOffset = 0;
    }
    this.setState({
      offset: newOffset
    });
    this.getFeedItems(newOffset);
  }

  getFeedItems(offset) {
    this.setState({
      loading: true
    });
    let self = this;

    Flagship.get(
      "log/read",
      {
        offset,
        target: self.props.recordId,
        count: 20
      },
      function(response) {
        if (response.data.success === true) {
          self.setState({
            items: response.data.results,
            loading: false
          });
        } else {
          self.setState({
            error: "Failed to load record history.",
            loading: false
          });
        }
      },
      function(err) {
        console.error("ERROR: " + err);
      }
    );
  }

  refreshFeed() {
    this.getFeedItems(this.state.offset);
  }

  getMessage(action) {
    if (Flagship.config.possibleActions.hasOwnProperty(action)) {
      return Flagship.config.possibleActions[action];
    }
    return "";
  }

  renderFieldDiff(label, newValue, oldValue, validation = false, key = false) {
    if (!isEqual(newValue, oldValue)) {
      if (validation) {
        if (validation !== "client-name") {
          oldValue = renderFieldValue(oldValue, validation);
          newValue = renderFieldValue(newValue, validation);
        } else {
          oldValue = oldValue.name;
          newValue = newValue.name;
        }
      } else {
        oldValue = renderFieldValue(oldValue);
        newValue = renderFieldValue(newValue);
      }

      return (
        <div
          className="single-field-change"
          key={key ? "change-" + key : label}
        >
          <Label>{label}</Label>
          <br />
          <div className="edit-value-values">
            {!empty(newValue) ? (
              <span className="edit-value-new">{newValue}</span>
            ) : null}
            {!empty(oldValue) ? (
              <span className="edit-value-old">{oldValue}</span>
            ) : null}
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  getData(action, data, name, key, type) {
    if (typeof type !== "undefined" && type !== null) {
      switch (action) {
        case "comment":
          return (
            <Feed.Extra text>
              <Segment
                className="cf"
                style={{ wordWrap: "break-word", maxWidth: "100%" }}
              >
                <Icon size="large" color="grey" name="quote left" />
                <Linkify properties={{ target: "_blank" }}>
                  <em>{addMentions(data.comment)}</em>
                </Linkify>
              </Segment>
            </Feed.Extra>
          );

        case "create-client":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                {typeof data.extra1 !== "undefined" && data.extra1 !== "" ? (
                  <div className="feed-user">
                    <Icon name="user" color="grey" />
                    <em>
                      <strong>DBS: </strong>{" "}
                      {getFormattedValue(data.extra1, "user")}
                    </em>
                  </div>
                ) : null}
              </Segment>
            </Feed.Extra>
          );

        case "create-line-item":
          if (!data.hasOwnProperty("lineItemKey")) {
            return (
              <Feed.Extra text>
                <Segment className="cf">
                  <div>
                    <Icon name="pin" color="grey" />
                    <em>
                      <strong>Added: </strong> {data}
                    </em>
                  </div>
                </Segment>
              </Feed.Extra>
            );
          }

          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Added: </strong>
                    {data.lineItemName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "create-io-product":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Added: </strong>
                    {typeof data === "string" ? (
                      data
                    ) : (
                      <span>{data.ioProductKey}</span>
                    )}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "update-line-item":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Updated: </strong> {data.lineItemName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "update-line-item-pricing":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="dollar" color="grey" />
                  <em>
                    <strong>Updated: </strong> {data.lineItemName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "update-io-product":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Updated: </strong> {data.ioProductName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "update-io-product-assignment":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Updated: </strong> {data.ioProductName}
                  </em>
                  <br />
                  <div className="flagship-single-field">
                    <Label style={{ marginBottom: ".5em" }}>New Assignee</Label>{" "}
                    {getFormattedValue(data.newAssignee, "user")}
                  </div>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "auto-subscribe-user":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                   <Icon name="pin" color="grey" />
                  <em>
                    This user was automatically subscribed due to a product assignment.
                  </em>
                  <br />
                  <div className="flagship-single-field">
                    <Label style={{ marginBottom: ".5em" }}>Auto-Subscribed User</Label>{" "}
                    {getFormattedValue(data.userId, "user")}
                  </div>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "subscribe-other-user":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                   <Icon name="pin" color="grey" />
                  <em>
                    The user above subscribed the user below.
                  </em>
                  <br />
                  <div className="flagship-single-field">
                    <Label style={{ marginBottom: ".5em" }}>Subscribed User</Label>{" "}
                    {getFormattedValue(data.userId, "user")}
                  </div>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "subscribe-self":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                   <Icon name="pin" color="grey" />
                  <em>
                    This user subscribed themself to this IO.
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "update-io-product-status":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Updated: </strong> {data.ioProductName}
                  </em>
                </div>
                <div className="statuses-feed">
                  <Label
                    content={
                      Flagship.config.records[type].ioProductStatuses[
                        data.oldStatus
                      ].label
                    }
                    className="strikethrough"
                  />
                  <Label
                    color={
                      Flagship.config.records[type].ioProductStatuses[
                        data.newStatus
                      ].color
                    }
                    content={
                      Flagship.config.records[type].ioProductStatuses[
                        data.newStatus
                      ].label
                    }
                  />
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "submit-io-product":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Submitted: </strong> {data.ioProductName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "launch-io-product":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="pin" color="grey" />
                  <em>
                    <strong>Queued: </strong> {data.ioProductName}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "change":
          if (
            data !== null &&
            typeof data.new === "string" &&
            typeof data.old === "string"
          ) {
            return (
              <Feed.Extra text>
                <Segment className="cf">
                  {this.renderFieldDiff(data.label, data.new, data.old)}
                </Segment>
              </Feed.Extra>
            );
          } else if (Array.isArray(data) && data.length) {
            let renderFieldDiff = this.renderFieldDiff;
            return (
              <Feed.Extra text>
                <Segment className="cf">
                  {typeof data.map === "function"
                    ? data.map(function(item, i) {
                        return renderFieldDiff(
                          item.label,
                          item.new,
                          item.old,
                          item.validation,
                          i
                        );
                      })
                    : null}
                </Segment>
              </Feed.Extra>
            );
          }
          break;
        case "change-status-io":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Label
                    color={Flagship.config.records[type].statuses[data].color}
                    content={Flagship.config.records[type].statuses[data].label}
                  />
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "change-status-rfp":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Label
                    color={Flagship.config.records[type].statuses[data].color}
                    content={Flagship.config.records[type].statuses[data].label}
                  />
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "file-upload":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="file" color="grey" />
                  <em>
                    <strong>Uploaded: </strong>
                    {data}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "proposal-upload":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <Icon name="file text outline" color="grey" />
                  <em>
                    <strong>Uploaded: </strong>
                    {data}
                  </em>
                </div>
              </Segment>
            </Feed.Extra>
          );
        case "change-business-closed":
          return (
            <Feed.Extra text>
              <Segment className="cf">
                <div>
                  <div
                    className="single-field-change"
                    key={key ? "change-" + key : "no-key"}
                  >
                    <Label>Date Business Closed</Label>
                    <br />
                    <div className="field-value feed-business-closed">
                      <Icon name="calendar" color="grey" />
                      {getFormattedValue(data, "date")}
                    </div>
                  </div>
                </div>
              </Segment>
            </Feed.Extra>
          );
      }
    }
  }

  renderPagination() {
    if (this.state.offset > 0 && this.state.items.length === 20) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button secondary onClick={this.prevPage}>
            Previous Page
          </Button>
          <Button.Or />
          <Button primary onClick={this.nextPage}>
            Next Page
          </Button>
        </Button.Group>
      );
    } else if (this.state.offset > 0) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button secondary onClick={this.prevPage}>
            Previous Page
          </Button>
        </Button.Group>
      );
    } else if (this.state.items.length === 20) {
      return (
        <Button.Group fluid className="activity-feed-pagination">
          <Button primary onClick={this.nextPage}>
            Next Page
          </Button>
        </Button.Group>
      );
    } else {
      return (
        <span>
          <br />
          No{" "}
          {this.state.offset === 0 && this.state.items.length === 0
            ? null
            : "other"}{" "}
          activity to display.
        </span>
      );
    }
  }

  render() {
    let self = this;

    return (
      <Segment className="fade-in recent-activity">
        <Feed>
          {this.state.error !== "" ? this.state.error : ""}
          {typeof this.state.items !== "undefined" ? (
            this.state.items.map(function(item, i) {
              let message = self.getMessage(item.action);

              if (item.action === "create-client") {
                message = "created this client";
              } else if (item.action === "submit-rfp") {
                message = "submitted this RFP";
              } else if (item.action === "submit-io") {
                message = "submitted this IO";
              }

              if (!empty(message)) {
                let timezone = getTimezone(self.props.userMarket);
                return (
                  <Feed.Event key={"feed-item-" + i}>
                    <Feed.Label>
                      { item.photo ? 
                      <img
                        src={Flagship.config.uploads + item.photo}
                        alt={item.first_name}
                      />: <img
                        src={Flagship.config.uploads + 'flagship.png'}
                        alt="Flagship"
                      />}
                    </Feed.Label>
                    <Feed.Content>
                      <Feed.Summary>
                        <Feed.User>
                          {item.first_name ? `
                          ${item.first_name + " " + item.last_name} `:`Flagship `}
                        </Feed.User>
                        <span> {message}</span>
                        <Feed.Date>
                          {moment(item.date, "YYYY-MM-DD hh:mm:ss")
                            .tz(timezone)
                            .format("MM/DD/YY LT z")}
                        </Feed.Date>
                      </Feed.Summary>

                      {self.getData(
                        item.action,
                        item.data,
                        item.record_name,
                        item.record_key,
                        item.record_type
                      )}
                    </Feed.Content>
                  </Feed.Event>
                );
              }
            })
          ) : (
            <div>Could not load feed.</div>
          )}
          {this.renderPagination()}
          <span>&nbsp;</span>&nbsp;
          {this.state.loading === true ? (
            <Loader
              className="flagship-loader"
              active={this.state.loading}
              inline
            />
          ) : null}
        </Feed>
      </Segment>
    );
  }
}

export default SingleRecordHistory;



// WEBPACK FOOTER //
// ./src/components/misc/SingleRecordHistory.js